module.exports = __webpack_public_path__ + "img/SandKing.d0eb61fd.png";